<template>
  <b-modal v-model="modalLanguage" :width="550" scroll="keep">
    <div class="card">
      <div class="card-content py-5">
        <h3 class="is-size-4 has-text-weight-bold mb-5">
          Información en inglés
        </h3>
        <hr />
        <div>
          <b-field
            label="Nombre"
            :custom-class="$v.data.name.$error ? 'has-text-danger' : ''"
            :type="{ 'is-danger': $v.data.name.$error }"
            :message="[
              {
                'Campo requerido':
                  !$v.data.name.required && $v.data.name.$error
              }
            ]"
          >
            <b-input v-model="data.name"></b-input>
          </b-field>
          <b-field
            label="Descripción"
            :custom-class="$v.data.description.$error ? 'has-text-danger' : ''"
            :type="{ 'is-danger': $v.data.description.$error }"
            :message="[
              {
                'Campo requerido':
                  !$v.data.description.required && $v.data.description.$error
              }
            ]"
          >
            <b-input v-model="data.description"></b-input>
          </b-field>
          <b-field label="Características">
            <vue-editor v-model="data.features" :editorToolbar="customToolbar">
            </vue-editor>
          </b-field>
          <b-field label="Especificaciones" class="doubleInput">
            <div class="doubleInput__container" v-for="(s, index) in data.specs" :key="index">
              <b-field label="Nombre">
                <b-input v-model="s.name"></b-input>
              </b-field>
              <b-field label="Descripción">
                <b-input v-model="s.value"></b-input>
              </b-field>
              <div class="dobleInput__delete">
                <b-button
                  type="is-danger"
                  size="is-small"
                  @click="delSpecs(index)"
                >
                  <font-awesome-icon :icon="['fas', 'trash']" />
                </b-button>
              </div>
              <br>
            </div>
            <b-button
              type="is-primary"
              size="is-small"
              @click="addSpecs"
            >
              Agregar <font-awesome-icon :icon="['fas', 'plus']" />
            </b-button>
          </b-field>
        </div>
        <hr />
        <div
          class="is-flex is-justify-content-flex-end w-full is-align-items-center"
        >
          <div>
            <Button
              variant="gray"
              @click.native="modalLanguage = false"
              >Cerrar</Button
            >
          </div>
          <div class="ml-3">
            <Button
              variant="main"
              :spinner="loading"
              @click.native="putInfo"
              >Guardar</Button
            >
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import Button from '@/components/form/Button'
import { required } from 'vuelidate/lib/validators'
import ProductService from '@/services/ProductService'
export default {
  components: {
    Button,
    VueEditor
  },
  props: {
    idProduct: Number
  },
  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link', 'image', 'video'],
        ['clean'] // remove formatting button
      ],
      modalLanguage: true,
      loading: false,
      data: {
        local: [],
        name: '',
        category: [],
        price: null,
        stock: null,
        has_stock: false,
        description: '',
        image: '',
        position: 1,
        is_active: true,
        title: '',
        meta_description: '',
        route_image: '',
        tags: [],
        size: null,
        unity: null,
        volumen: null,
        weight: null,
        specs: [],
        features: ''
      }
    }
  },
  validations: {
    data: {
      name: { required },
      description: { required }
    }
  },
  watch: {
    modalLanguage() {
      this.$emit('hidden')
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    errorMessage() {
      this.$store.commit('settings/SET_ALERT', {
        isAlert: true,
        type: 'D',
        msg: 'Ocurrió un error.'
      })
    },
    async getInfo() {
      try {
        const response = await ProductService.getDetail(this.idProduct, 'en')
        this.data = response.data
      } catch (error) {
        this.modalLanguage = false
        this.errorMessage()
      }
    },
    async putInfo() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        try {
          await ProductService.putDetail(this.idProduct, this.data, 'en')
          this.$store.commit('settings/SET_ALERT', {
            isAlert: true,
            type: 'S',
            msg: 'Se guardó correctamente.'
          })
          this.modalLanguage = false
          this.$emit('reload')
        } catch (error) {
          this.loading = false
          this.$store.commit('settings/SET_ALERT', {
            isAlert: true,
            type: 'D',
            msg: 'Ocurrió un error.'
          })
        }
      }
    },
    addSpecs() {
      if (this.data.specs.length > 0) {
        const item = this.data.specs.length - 1
        if (this.data.specs[item].name !== '' && this.data.specs[item].value !== '') {
          this.data.specs.push({ name: '', value: '' })
        }
      } else {
        this.data.specs.push({ name: '', value: '' })
      }
    },
    delSpecs(index) {
      this.data.specs.splice(index, 1)
    }
  }
}
</script>
